<template>
  <b-modal
    ref="modal"
    hide-footer
    title="Exportar Relatório"
    centered
    content-class="export-choice-modal"
  >
    <div class="d-flex flex-column align-items-center justify-content-center">
      <b-button
        variant="third"
        class="mb-3 w-75"
        size="lg"
        @click="exportExcel"
      >
        <i class="fas fa-file-excel mr-2"></i> Exportar para Excel
      </b-button>
      <b-button
        variant="primary"
        class="w-75"
        size="lg"
        @click="exportEmail"
      >
        <i class="fas fa-envelope mr-2"></i> Enviar por Email
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  methods: {
    openModal () {
      this.$refs.modal.show()
    },
    exportExcel () {
      this.$refs.modal.hide()
      this.$emit('exportExcel')
    },
    exportEmail () {
      this.$refs.modal.hide()
      this.$emit('exportEmail')
    }
  }
}
</script>

<style scoped>
.export-choice-modal {
  min-width: 350px;
  max-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/relatorios_atendimento/modal/ExportChoiceModal.vue